// DEMO auth service — fully client-side, no backend/API.
// Credentials are hardcoded (demo/demo). See ТЗ п.2.

const DEMO_LOGIN = 'demo'
const DEMO_PASSWORD = 'demo'
const DEMO_TOKEN = 'demo-auth-token'

const delay = (value, ms = 350) =>
	new Promise(resolve => setTimeout(() => resolve(value), ms))

const AuthService = {}

// authSlice.signIn passes { email, password }. In the demo the "email"
// field carries the username ("demo"); we keep the key to avoid touching the slice.
AuthService.login = function ({ email, password } = {}) {
	const login = (email || '').trim()
	if (login === DEMO_LOGIN && password === DEMO_PASSWORD) {
		return delay({ data: { token: DEMO_TOKEN } })
	}
	// Mimic an axios-style rejection so the slice's error branch works unchanged.
	return delay(null).then(() => {
		return Promise.reject({
			response: { data: { message: 'Login yoki parol xato' } }
		})
	})
}

AuthService.register = function () {
	// Registration is out of scope for the demo.
	return delay({ data: { token: DEMO_TOKEN } })
}

AuthService.logout = function () {
	return delay({ data: {} })
}

AuthService.loginInOAuth = function () {
	// OAuth is disabled in the demo; resolve with the demo token if ever called.
	return delay({ data: { token: DEMO_TOKEN } })
}

export default AuthService;
